import { PropsWithChildren } from "react";
import { Stack } from "@fluentui/react/lib/Stack";

import { ITileFooterProps } from "./ITileFooterProps";
import { useTileFooterStyles } from "./UseTileFooterStyles";

export function TileFooter(props: PropsWithChildren<ITileFooterProps>): JSX.Element {
  const { children, styleSet } = props;
  const styles = useTileFooterStyles(styleSet);
  return (
    <Stack horizontal grow={0} disableShrink className={styles.root}>
      {children}
    </Stack>
  );
}
